import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Button from '@eig-builder/core-ui/Button'

import { DataElementLocations } from '@eig-builder/core-utils/helpers/tagging-helper'

import ButtonWithLoader from 'core/components/button-with-loader'
import Modal from 'core/components/modal'

import Content from './content'
import usePostAsJson from '@eig-builder/core-utils/hooks/usePostAsJson'
import { getCrmApiOptions } from '../../../../helpers/fetch-options-helper'

const RemovePaymentMethodModal = ({ account, handleClose }) => {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('')

  const [removeReq, doDelete] = usePostAsJson()

  const handleDeletePaymentMethod = () => {
    doDelete({}, getCrmApiOptions(account, `/v1.0/billing/remove_payment_method?billingInfoId=${selectedPaymentMethod}`))
  }

  const actions = [
    <Button
      key='close-button'
      variant='outlined'
      disabled={removeReq.isLoading}
      dataElementLocation={DataElementLocations.POP_UP}
      dataElementLabel='cst-account--remove-payment-method--close'
      dataElementId='cst-account--remove-payment-method--close'
      onClick={handleClose}
    >
      Close
    </Button>,
    <ButtonWithLoader
      key='remove-button'
      color='error'
      disabled={!selectedPaymentMethod || removeReq.isLoading}
      showLoader={removeReq.isLoading}
      text='Remove'
      dataElementLocation={DataElementLocations.POP_UP}
      dataElementSuffix='remove-payment-method--remove'
      dataElementId='remove-payment-method--remove'
      onClick={handleDeletePaymentMethod}
    />
  ]

  return <Modal
    open
    actions={actions}
    handleClose={handleClose}
    dataElementPrefix='cst-account--remove-payment-method'
    title='Remove payment method'
    maxWidth='md'
  >
    <Content
      account={account}
      removeReq={removeReq}
      setPaymentMethod={setSelectedPaymentMethod}
      />
  </Modal>
}

RemovePaymentMethodModal.propTypes = {
  account: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired
}

export default RemovePaymentMethodModal
